module.exports = __webpack_public_path__ + "static/media/triangle1.32358e8d.svg";